import "react18-json-view/src/style.css";

import {
  Card,
  CardBody,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import { DynamicForm } from "features/internal/template/form/DynamicForm";
import {
  useInternalEventTemplateEventCreateDataRetrieveSuspense,
  useInternalEventTemplateVersionRetrieveSuspense,
} from "gen/endpoints/internal/internal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import JsonView from "react18-json-view";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const InternalTemplateEventPage: React.FC = () => {
  const { t } = useTranslation(["common", "internal"]);
  const { templateVersionId, templateEventId } = useRequiredStringParams();

  const { data: templateData } =
    useInternalEventTemplateVersionRetrieveSuspense(templateVersionId);

  const { data: eventTemplateObjectCreateData } =
    useInternalEventTemplateEventCreateDataRetrieveSuspense(
      templateVersionId,
      templateEventId,
    );

  const schema = JSON.parse(eventTemplateObjectCreateData.json_schema);
  const [formData, setFormData] = useState(() =>
    JSON.parse(eventTemplateObjectCreateData.json_str as unknown as string),
  );

  return (
    <PageContent isFullHeight={true}>
      <PageHeader
        title="Event"
        helperText={templateData.name}
        backButton={{
          title: t("common:back"),
          path: rootRoute({})
            .internal({})
            .shadowTemplate({ templateVersionId })
            .template({}).$,
        }}
      />
      <PageBody>
        <Tabs isLazy={true}>
          <TabList>
            <Tab>Form</Tab>
            <Tab>JSON</Tab>
            <Tab>JSON Schema</Tab>
          </TabList>
          <TabPanels>
            <TabPanel>
              <DynamicForm
                schema={schema}
                formData={formData}
                setFormData={setFormData}
              />
            </TabPanel>
            <TabPanel>
              <Card>
                <CardBody>
                  <JsonView src={formData} />
                </CardBody>
              </Card>
            </TabPanel>
            <TabPanel>
              <Card>
                <CardBody>
                  <JsonView src={schema} />
                </CardBody>
              </Card>
            </TabPanel>
          </TabPanels>
        </Tabs>
      </PageBody>
    </PageContent>
  );
};
